import { render, staticRenderFns } from "./veSbzcCdCategoryEdit.vue?vue&type=template&id=61be3f8b&scoped=true"
import script from "./veSbzcCdCategoryEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcCdCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be3f8b",
  null
  
)

export default component.exports